import { Box, Card, CardContent, CircularProgress } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import "../../Assets/css/globalStyle.css";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Axios from "axios";
import Swal from "sweetalert2";

const PaymentStatus = () => {
  const { id } = useParams();
  const [responseData, setResponseData] = useState({});
  const [transferData, setTransferData] = useState({});
  const [applicationStatus, setApplicationStatus] = useState({});
  const [transStatus, setTransStatus] = useState('')
  const [loading, setLoading] = useState(false);
  const [TransactionId, setTransactionId] = useState({});
  const [refNext, setRefNext] = useState(false);
  const [reqBodyPaymentStatus, setReqBodyPaymentStatus] = useState({});

  const navigate = useNavigate();
  const location = useLocation();
  console.log("sss", location);
  //let reqBodyPaymentStatus = {};

  const productIdArray = id.split("*");
  //const productRef = productIdArray[0]
  const transId = productIdArray[0];
  const validateFormid = productIdArray[1];

 console.log('transId',transId)
  

  if (
    Object.keys(transferData).length > 0 &&
    Object.keys(TransactionId).length > 0 
    && Object.keys(applicationStatus).length > 0
  ) {
    //setReqBody()
    //setReqBodyPaymentStatus(reqBody);
    console.log("transId", TransactionId);
    let updateTransferData = {
      ...transferData,
      TransactionId: TransactionId,
      payment: {...applicationStatus}
    };
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "it.acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios
      .put(
        `${domain}/api/shriram/plp-validate-response/${transId}/`,
        updateTransferData
      )
      .then((response) => {
        console.log('dfdff',response)
        if (response.status === 200) {
          console.log("response in validate updated trans", response);
         
          // setTransferData(response.data);
        }
      }).catch(e=>{
        console.log('eer',e)
      });
  }

  

  const getTransferData = () => {
    setLoading(false);
    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "it.acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.get(`${domain}/api/shriram/plp-validate-response/${transId}/`).then(
      (response) => {
        if(response.data != null){
          let userId = response.data.UserID
          let appNo = response.data.ApplicationNo
          let A_id = response.data.A_id

          setTransferData(response.data);
          getPaymentStatusData(userId,appNo,A_id)
        }
        setLoading(true);
        console.log("trans of paymentStatus", response);
      }
    );
  };

  const getPaymentStatusData = (userId,appNo,A_id) => {
    setLoading(false);
    let reqBody= {
      UserID: userId,
      ApplicationNo: appNo,
    };
console.log('requestBody',reqBody)

    let domain = "";
    if (window.location.hostname === "localhost") {
      domain = process.env.REACT_APP_LOCAL_DJANGO;
    } else if (window.location.hostname.trim() === "it.acuvisor.com") {
      domain = process.env.REACT_APP_PRODUCTION_DJANGO;
    } else {
      domain = process.env.REACT_APP_UAT_DJANGO;
    }

    Axios.post(
      `${domain}/api/life-insurance/payment-status/${A_id}/`,
      reqBody
    ).then((response) => {
      if (response.status === 200) {
        console.log("response from payment ", response);
        let paymentStatus ={
          //...response.data.ResultSet.Response,
          //'TxnRef':response.data.ResultSet.TxnRef,
          "TransactionDate":response.data.ResultSet.Response.TranasactionDate,
          //"TransactionRefNo": response.data.ResultSet.TxnRef,
          "TransactionRefNo":response.data.ResultSet.Response.TranasactionID
          //"TransationAmount": 
        }
        setApplicationStatus(paymentStatus);
        setTransStatus(response.data.ResultSet.Response.PaymentStatus)
        setLoading(true);

        if (response.data.ResultSet.Response.PaymentStatus === "Successful") {
          setRefNext(true);
        }
      }
    });
  };

console.log('appli',applicationStatus)

  const nextButtonHandler = () => {
    console.log("hh", refNext);
    if (refNext) {
      navigate(
        `/life-insurance/submitproposal/${transferData.sp_config_id}*${transId}*${validateFormid}`
      );
    } else {
      Swal.fire({
        icon: "error",
        title: "Your payment had been unsuccessful or pending.",
        text: 'To make another payment, kindly click the "OK" button.',
        position: "center",
      }).then((result) => {
        console.log("swl", result);
        if (result.isConfirmed) {
          navigate(
            `/life-insurance/paypremium/${transferData.payment_config_id}*${transId}*${validateFormid}`
          );
        }
      });
    }
  };

  useEffect(() => {
    getTransferData();
    //getPaymentStatusData();
    //setReqBody()
    if (location.search === "") {
    } else {
      console.log("loc", location.search.split("="));
      let encryptId = location.search.split("=");
      setTransactionId(encryptId[1]);
    }
  }, []);

  return (
    <>
      <CategoryHeader title="Life Insurance" />
      {loading ? (
        <div>
          <Box sx={{ padding: "16px", minHeight: "100%", marginTop: "16px" }}>
            {transferData && (
              <Card>
                <CardContent
                  sx={{
                    minHeight: "600px",
                    justifyContent: "center",
                    alignContent: "center",
                  }}
                >
                  <h3 className="texxxt">
                    <b>Transaction {transStatus}</b>
                  </h3>

                  <h3>
                    <b>Application no. - {transferData.ApplicationNo} </b>
                  </h3>
                </CardContent>
              </Card>
            )}
          </Box>

          <div className="btn-sec position-fixed bottom-0 mt-3 ">
            <button className="Goback_btn text-capitalize">Back </button>

            <button
              className="submitBtn text-capitalize"
              onClick={nextButtonHandler}
            >
              Next{" "}
            </button>
          </div>
        </div>
      ) : (
        <div className="d-flex justify-content-center ">
          <CircularProgress
            size={48}
            sx={{
              color: "red",
            }}
          />
        </div>
      )}
    </>
  );
};

export default PaymentStatus;
